import { useIsFetching, useIsMutating } from '@tanstack/react-query';

import { useLoadingStore } from '~/store';

/**
 * 전역 로딩 상태를 통합 관리하는 훅
 *
 * - React Query의 isFetching/isMutating과 수동 loadingCount를 통합
 * - meta.background: true 인 쿼리는 전역 로딩에서 제외
 * - meta.dimmed: false 인 쿼리가 있으면 dimmed: false로 표시
 */
const useGlobalLoading = () => {
  const isFetching = useIsFetching({
    predicate: (query) => !query.meta?.background,
  });
  const isMutating = useIsMutating({
    predicate: (mutation) => !mutation.meta?.background,
  });

  const isFetchingNonDimmed = useIsFetching({
    predicate: (query) => !query.meta?.background && query.meta?.dimmed === false,
  });
  const isMutatingNonDimmed = useIsMutating({
    predicate: (mutation) => !mutation.meta?.background && mutation.meta?.dimmed === false,
  });

  const { loadingCount, dimmed: storeDimmed } = useLoadingStore();

  /** @TODO React Query 전환 후 loadingCount 제거 */
  const isLoading = isFetching > 0 || isMutating > 0 || loadingCount > 0;

  const dimmed = isFetchingNonDimmed > 0 || isMutatingNonDimmed > 0 ? false : storeDimmed;

  return { isLoading, dimmed };
};

export default useGlobalLoading;
